import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IAction } from "reduxsauce";

import { Creators as AllCreators } from "../../../actions";
import { IState } from "../../reducer";
import { IClass, ICourse } from "../../types/common";
import { FetchPartInstanceAnalytics, IUnitsAnalytics, IUser, IUsersAnalytics } from "../Common";
import CommonAnalytics from "../Main";
import {
  FetchAllUsersRequestState,
  FetchClassDataRequestState,
  FetchCourseDataRequestState,
  FetchUsersAnalyticsRequestState,
} from "./reducer";

const Creators = (AllCreators as any).App.ClassAnalytics;
const AppCreators = (AllCreators as any).App;

export interface IClassAnalyticsOwnProps {
  courseId: string;
  objectId: string;
}

export interface IClassAnalyticsStateProps {
  fetchScormPackageDataRequestState: null;
  fetchPartInstanceAnalytics: FetchPartInstanceAnalytics;
  fetchAllUsersRequestState: FetchAllUsersRequestState;
  fetchClassDataRequestState: FetchClassDataRequestState;
  fetchCourseDataRequestState: FetchCourseDataRequestState;
  fetchUsersAnalyticsRequestState: FetchUsersAnalyticsRequestState;
  course: ICourse | null;
  class: IClass | null;
  scormPackage: null;
  unitsAnalytics: IUnitsAnalytics[] | null;
  users: IUser[] | null;
  usersAnalytics: IUsersAnalytics | null;
}

export interface IClassAnalyticsDispatchProps {
  mount: () => void;
  unmount: () => void;
  print: () => void;
}

export default connect<IClassAnalyticsStateProps, IClassAnalyticsDispatchProps, IClassAnalyticsOwnProps, IState>(
  (state: IState, ownProps: IClassAnalyticsOwnProps) => ({
    class: state.App.ClassAnalytics._.class,
    course: state.App.ClassAnalytics._.course,
    fetchAllUsersRequestState: state.App.ClassAnalytics._.fetchAllUsersRequestState,
    fetchClassDataRequestState: state.App.ClassAnalytics._.fetchClassDataRequestState,
    fetchCourseDataRequestState: state.App.ClassAnalytics._.fetchCourseDataRequestState,
    fetchPartInstanceAnalytics: state.App.ClassAnalytics._.fetchClassPartInstSummaryRollup,
    fetchScormPackageDataRequestState: null,
    fetchUsersAnalyticsRequestState: state.App.ClassAnalytics._.fetchUsersAnalyticsRequestState,
    scormPackage: null,
    unitsAnalytics: state.App.ClassAnalytics._.unitsAnalytics,
    users: state.App.ClassAnalytics._.users,
    usersAnalytics: state.App.ClassAnalytics._.usersAnalytics,
  }),
  (dispatch: Dispatch<IAction>, { courseId, objectId }: IClassAnalyticsOwnProps) => ({
    mount: () => {
      dispatch(Creators.mount(courseId, objectId));
      dispatch(Creators.fetchCourseData(courseId));
      dispatch(Creators.fetchClassData(objectId));
      dispatch(Creators.fetchAllUsers(courseId, objectId));
      dispatch(Creators.fetchUsersAnalytics(courseId, objectId));
    },
    print: () => dispatch(AppCreators.printCurrentPage()),
    unmount: () => dispatch(Creators.unmount(courseId, objectId)),
  })
)(CommonAnalytics);
